'use strict'

import angular from 'angular'

import buySheetPanelComponentHtmlUrl from './buySheetPanel.component.html'

angular.module('buySheet.components').component('buySheetPanel', {
    templateUrl: buySheetPanelComponentHtmlUrl,
    bindings: {
        entity: '<',
        entityName: '@',
        listType: '@',
        entitiesTablesHeaders: '<',
        subEntitiesType: '@'
    },
    controller() {
        this.entityNameTitle = this.entityName.charAt(0).toUpperCase() + this.entityName.slice(1)
        this.entitiesType = this.entityNameTitle.slice(0, this.entityNameTitle.length - 1)
    },
    controllerAs: 'vm'
})